import {
  postJsMessage,
  registerSpecificNotificationHandler,
  unregisterSpecificNotificationHandler,
} from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';
import { Notification } from '../../utils/type';
import type {
  GetNakOption,
  NakResponse,
  ZakResponse,
  PakResponse,
} from './types';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.getNak
 *
 * [PLATFORM]
 * mac        6.1.10+
 * windows    6.1.10+
 * linux      6.1.10+
 * ios        6.1.10+
 * android    6.1.10+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getNak(
  param: GetNakOption = {},
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<NakResponse>> {
  await isAvailable('auth.getNak');
  return postJsMessage<GetNakOption, NakResponse>(API.getNak, param, options);
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.getZak
 *
 * [PLATFORM]
 * mac        6.2.5+
 * windows    6.2.5+
 * linux      6.2.5+
 * ios        6.2.5+
 * android    6.2.5+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getZak(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<ZakResponse>> {
  await isAvailable('auth.getZak');
  return postJsMessage(API.getZak, {}, options);
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.onZakUpdated
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function onZakUpdated(
  zakUpdatedHandler: (zakUpdatedNotification: Notification<ZakResponse>) => void
) {
  registerSpecificNotificationHandler(
    'UnifyNotify_OnZakUpdated',
    zakUpdatedHandler
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.offZakUpdated
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function offZakUpdated(
  zakUpdatedHandler: (zakUpdatedNotification: Notification<ZakResponse>) => void
) {
  unregisterSpecificNotificationHandler(
    'UnifyNotify_OnZakUpdated',
    zakUpdatedHandler
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.getPak
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getPak(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<PakResponse>> {
  await isAvailable('auth.getPak');
  return postJsMessage(API.getPak, {}, options);
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.refreshPak
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function refreshPak(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<PakResponse>> {
  await isAvailable('auth.refreshPak');
  return postJsMessage(API.refreshPak, {}, options);
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.onPakUpdated
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function onPakUpdated(
  PakUpdatedHandler: (PakUpdatedNotification: Notification<PakResponse>) => void
) {
  registerSpecificNotificationHandler(
    'UnifyNotify_OnPakUpdated',
    PakUpdatedHandler
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.offPakUpdated
 *
 * [PLATFORM]
 * mac        6.5.0+
 * windows    6.5.0+
 * linux      6.5.0+
 * ios        6.5.0+
 * android    6.5.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function offPakUpdated(
  PakUpdatedHandler: (PakUpdatedNotification: Notification<PakResponse>) => void
) {
  unregisterSpecificNotificationHandler(
    'UnifyNotify_OnPakUpdated',
    PakUpdatedHandler
  );
}
export default {
  getZak,
  getNak,
  onZakUpdated,
  offZakUpdated,
  getPak,
  refreshPak,
  onPakUpdated,
  offPakUpdated,
};
